import { SafeHtml } from '@angular/platform-browser';

export enum NotebookVizState {
  Loading = 'loading',
  Empty = 'empty',
  Succeeded = 'succeeded',
  Failed = 'failed',
  Skipped = 'skipped',
}

export interface NotebookVizResult {
  token: string; // viz token
  content: string | SafeHtml;
  result_type: string;
  date: string;
  content_type: string;
}

// for backwards compatibility with python components that expect a type property
export interface NotebookEmbedVizResult extends NotebookVizResult {
  type: string; // content_type alias
}

export interface NotebookVizRender {
  _name: 'pythonVisualization'; // required by VizContainer
  id: string;
  token: string;
  title: string;
  frozen: boolean;
  state: NotebookVizState;
  vizLink: string;
  vizReportRunLink: string;
  results: NotebookEmbedVizResult[];
}
